import { useEffect, useRef, useState, useCallback } from "react";

export function useBroadcastChannel<T = any>(
  channelName: string,
  onMessage: (data: T) => void
) {
  const channelRef = useRef<BroadcastChannel | null>(null);
  const [isActiveTab, setIsActiveTab] = useState(
    document.visibilityState === "visible"
  );

  // Listen for tab visibility changes
  useEffect(() => {
    const handleVisibility = () => {
      setIsActiveTab(document.visibilityState === "visible");
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel(channelName);
    channelRef.current = channel;

    const handler = (event: MessageEvent) => {
      onMessage(event.data);
    };

    channel.addEventListener("message", handler);

    return () => {
      channel.removeEventListener("message", handler);
      channel.close();
    };
  }, [channelName, onMessage]);

  // Only send messages if this is the active tab
  const postMessage = useCallback(
    (data: T) => {
      if (document.visibilityState === "visible") {
        channelRef.current?.postMessage(data);
      }
    },
    [channelRef]
  );

  return { postMessage, isActiveTab };
}
